import { GrowButton } from "@sinecycle/growcomponents";

function AntButton(props: React.ComponentProps<typeof GrowButton>) {
  return <GrowButton {...props} />;
}

export { AntButton as Button };
